<template>
  <div>
    <ul
      ref="list"
      :aria-expanded="isOpened"
      :aria-hidden="!isOpened"
      role="listbox"
    >
      <li
        v-for="(item, index) in searchItems"
        :key="`${item}-${index}`"
        tabindex="0"
        class="base-search__list-item input-text"
        :class="[
          (valueKey ? item[valueKey] : item) === value && 'active'
        ]"
        @click="onSelect(item)"
      >
        {{ item[suffix] ? `${item.label} (${item[suffix]})` : item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'BaseTab',

    props: {
      searchUrl: String,
      instantSearch: {
        type: Boolean,
        default: false
      },
      suffix: {
        type: String,
        default: ''
      },
      items: Array
    },

    data () {
      return {
        isOpened: false,
        isCollapsed: true,
        search: '',
        searchItems: [
          {
            label: 'test'
          },
          {
            label: 'test 2s'
          }

        ]
      }
    },

    computed: {
    },

    watch: {
      search (v) {
        // if (v === _get(this.searchItems, '0.label')) {
        // setTimeout(() => {
        //   this.onSelect(_get(this.searchItems, '0'))
        // }, 200)
        // }
      }
    },

    created () {
      // if (_get(this.items, 'length') && (this.value || this.value === 0)) {
      //   const item = this.items.find(item => item.value === this.value)
      //   this.onSelect(item)
      // }
    },

    methods: {
    }
  }
</script>

<style lang="scss">
  .a {
    color: red;
  }
</style>
